import React from 'react';
import styles from './Footer.module.scss';

const Footer: React.FC = () => (
  <div className={styles.container} />
);

export default Footer;
